import { render, staticRenderFns } from "./AddImages.vue?vue&type=template&id=5f3c0819"
import script from "./AddImages.vue?vue&type=script&lang=js"
export * from "./AddImages.vue?vue&type=script&lang=js"
import style0 from "./AddImages.vue?vue&type=style&index=0&id=5f3c0819&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports